<div id="crop-health-note-form">
  @if (!note) {
    <p class="page-title">
      <i class="ph-bold ph-caret-left back-icon" (click)="onBackBtn()"></i>
      @if (problematicSpots?.length > 0) {
        {{ 'doktar_app.services.crop_monitoring.check_problem_spot' | translate }} ({{
          currentProblematicSpotIndex + 1
        }}/{{ problematicSpots?.length }})
      } @else {
        <span>{{ 'doktar_app.services.crop_monitoring.add_a_note' | translate }}</span>
      }
    </p>
  }
  @if (problematicSpots?.length > 0) {
    <p class="description">
      {{ 'doktar_app.services.crop_monitoring.check_problem_spot_description' | translate }}
    </p>
  } @else {
    <p class="description">{{ 'doktar_app.services.crop_monitoring.add_note_description' | translate }}</p>
  }
  <p class="description d-flex gap-2" [class.d-none]="!disableAll">
    <i class="ph-fill ph-info icon"></i>
    <span>{{ 'doktar_app.services.crop_monitoring.add_note_warning' | translate }}</span>
  </p>
  @if (form) {
    <form [formGroup]="form">
      @if (problematicSpots?.length > 0) {
        <div class="problameticSpot">
          <div class="main-label mb-2">
            {{ 'doktar_app.services.crop_monitoring.status_of_problem' | translate }}
          </div>
          <div class="row">
            <div class="col-6">
              <dk-button
                class="problameticSpotBtn"
                [label]="'doktar_app.services.crop_monitoring.problem_detected' | translate"
                [severity]="selectedProblematicSpotStatus == 'problemDetected' ? 'primary' : 'secondary'"
                (onClick)="updateProblemSpot('problemDetected')" />
            </div>
            <div class="col-6">
              <dk-button
                class="problameticSpotBtn"
                [label]="'doktar_app.common.no_problem' | translate"
                [severity]="selectedProblematicSpotStatus == 'noProblem' ? 'primary' : 'secondary'"
                (onClick)="updateProblemSpot('noProblem')" />
            </div>
          </div>
        </div>
      }
      <div class="px-2" [class.disabled]="disableAll || disableForm">
        <div class="note-label">
          <div class="label">
            <span>
              <span class="main-label">{{ 'doktar_app.services.crop_monitoring.note_title' | translate }}</span>
              <span class="secondary-label"
                >({{
                  problematicSpots?.length > 0
                    ? ('doktar_app.common.optional' | translate)
                    : ('doktar_app.common.required' | translate)
                }})</span
              >
            </span>
            <span class="char-count"> {{ notTitleLength }}/20 </span>
          </div>
          <input type="text" formControlName="noteTitle" maxlength="20" />
        </div>
        <p class="note-tag-title">
          <span class="main-label">
            {{ 'doktar_app.services.crop_monitoring.type_of_problem' | translate }}
          </span>
          <span class="secondary-label"
            >({{
              problematicSpots?.length > 0
                ? ('doktar_app.common.optional' | translate)
                : ('doktar_app.common.required' | translate)
            }})</span
          >
        </p>
        <div class="note-tag-selections">
          @for (noteTag of noteTags; track noteTag) {
            <span class="note-tag" (click)="!disableAll && !disableForm ? (selectedNoteTag = noteTag.key) : null">
              <img [src]="noteTag.icon" />

              <span class="type-label">{{ noteTag.value }}</span>
              @if (selectedNoteTag == noteTag.key) {
                <i class="ph-fill ph-radio-button icon"></i>
              }
            </span>
          }
        </div>

        <div class="note-content">
          <div class="label">
            <span>
              <span class="main-label">{{ 'doktar_app.common.description' | translate }}</span>
              <span class="secondary-label">({{ 'doktar_app.common.optional' | translate }})</span>
            </span>
            <span class="char-count"> {{ notcontentLength }}/1000 </span>
          </div>
          <textarea rows="5" formControlName="noteContent" maxlength="1000"></textarea>
        </div>

        <div class="px-2">
          <div class="upload-photo-container row">
            @if (noteFiles.length > 0) {
              <div class="selected-photos col-auto">
                @for (file of noteFiles; track file) {
                  <div class="selected-photo">
                    <img [src]="file.photoUrl" alt="" width="30px" height="30px" />
                    <div class="remove-photo" [class.d-none]="fileUploadLoading" (click)="removeImgFile(file)">
                      <i class="ph-bold ph-x"></i>
                    </div>
                  </div>
                }
              </div>
              <div class="col">
                <dk-button
                  severity="secondary"
                  (onClick)="!disableAll && !disableForm && !fileUploadLoading ? chooseFile.click() : null">
                  @if (!fileUploadLoading) {
                    <span class="main-label">{{ 'doktar_app.common.add' | translate }}</span>
                  } @else {
                    <span class="uploading-file">
                      <span class="px-2">
                        {{ 'doktar_app.services.crop_monitoring.note.uploading_file_message' | translate }}
                      </span>
                      <i class="pi pi-spin pi-spinner-dotted"></i>
                    </span>
                  }
                </dk-button>
              </div>
            } @else {
              @if (!fileUploadLoading) {
                <div class="add-first-photo" (click)="chooseFile.click()">
                  <i class="ph-fill ph-image icon"></i>
                  <span class="main-label">{{
                    'doktar_app.services.crop_monitoring.note.add_photos' | translate
                  }}</span>
                  <span class="secondary-label">({{ 'doktar_app.common.optional' | translate }})</span>
                </div>
              } @else {
                <span class="uploading-file">
                  <span class="px-2">
                    {{ 'doktar_app.services.crop_monitoring.note.uploading_file_message' | translate }}
                  </span>
                  <i class="pi pi-spin pi-spinner-dotted"></i>
                </span>
              }
            }
            <input type="file" hidden #chooseFile accept="image/*" (change)="onSelectFile($event)" />
          </div>
        </div>
      </div>
    </form>

    <div class="btns row">
      @if (note || (!(problematicSpots?.length > 0) && !note?.problematicSpotId)) {
        <div class="col-4">
          <dk-button
            id="note-cancel-btn"
            severity="secondary"
            [label]="'doktar_app.common.cancel_button' | translate"
            [disabled]="fileUploadLoading"
            (onClick)="cancel()" />
        </div>
        <div class="col-8 px-0">
          <dk-button
            id="note-save-btn"
            severity="primary"
            type="submit"
            [disabled]="(disableAll && !disableForm) || fileUploadLoading"
            [label]="'doktar_app.services.crop_monitoring.note.save_note' | translate"
            (onClick)="!note?.problematicSpotId ? saveNote() : saveProblematicSpotNote()">
            @if (submitLoading) {
              <i class="pi pi-spin pi-spinner-dotted"></i>
            }
          </dk-button>
        </div>
      } @else {
        @if (currentProblematicSpotIndex < problematicSpots?.length - 1) {
          <div class="col-4">
            <dk-button
              id="note-skip-btn"
              severity="secondary"
              [label]="'doktar_app.common.skip' | translate"
              [disabled]="fileUploadLoading"
              (onClick)="next(true)">
              @if (submitLoading) {
                <i class="pi pi-spin pi-spinner-dotted"></i>
              }
            </dk-button>
          </div>
          <div class="col-8 px-0">
            <dk-button
              id="note-next-btn"
              severity="primary"
              [disabled]="disableAll || fileUploadLoading"
              type="submit"
              [label]="'doktar_app.common.next_button' | translate"
              (onClick)="next()">
              @if (submitLoading) {
                <i class="pi pi-spin pi-spinner-dotted px-2"></i>
              }
            </dk-button>
          </div>
        } @else {
          <div>
            <dk-button
              id="note-done-btn"
              severity="primary"
              [disabled]="disableAll || fileUploadLoading"
              type="submit"
              [label]="'doktar_app.common.done_button' | translate"
              (onClick)="saveProblematicSpotNote()">
              @if (submitLoading) {
                <i class="pi pi-spin pi-spinner-dotted px-2"></i>
              }
            </dk-button>
          </div>
        }
      }
    </div>
  }
</div>
